/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { useWindowSize } from "@react-hook/window-size";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

import { DEFAULT_PAGE_WIDTH } from "@vienna/common";

interface Props {
  children?: React.ReactNode[] | React.ReactNode;
}
export function ZoomWrapper({ children }: Props) {
  const [windowWidth] = useWindowSize();
  const scale = windowWidth / DEFAULT_PAGE_WIDTH;

  return (
    <TransformWrapper initialScale={scale} disabled={true}>
      <TransformComponent wrapperStyle={{ width: "100vw" }}>{children}</TransformComponent>
    </TransformWrapper>
  );
}
